import { ComissaoConselheiroAtuacaoResponse, ComissaoEstatisticaAnaliticoResponse } from '@/core/api/sicom-api/comissoes/estatisticas/comissao-estatistica.model';
import { PendenciaLinha } from '../../gestao-administrativa/mapa-pendencias/pendencia-linha.model';
import { iniciais } from '../ranking-reunioes/ranking-reunioes.model';

export interface RankingConselheiro {
    posicao: number;
    idSolicitante: number | null;
    nome: string;
    uf: string;
    valor: number;
    percentual: number;
    iniciais: string;
    /** Reuniões consideradas no cálculo. Sem isso, 100% de 1 reunião e de 12 ficam indistinguíveis. */
    base: number;
}

export function montarRankingConselheiros(linhas: ComissaoConselheiroAtuacaoResponse[], valor: (linha: ComissaoConselheiroAtuacaoResponse) => number): RankingConselheiro[] {
    // Desempate pela base: num ranking percentual, empatar em 100% é comum e a ordem não pode ser arbitrária.
    const ordenados = [...(linhas ?? [])].sort((a, b) => (valor(b) || 0) - (valor(a) || 0) || (b.totalRegistros || 0) - (a.totalRegistros || 0));
    const maior = ordenados.length ? valor(ordenados[0]) || 0 : 0;
    return ordenados.map((linha, indice) => {
        const total = valor(linha) || 0;
        const nome = linha.nmSolicitante || 'Conselheiro';
        return {
            posicao: indice + 1,
            idSolicitante: linha.idSolicitante ?? null,
            nome,
            uf: linha.ufSgUf || '-',
            valor: total,
            percentual: maior > 0 ? Math.round((total / maior) * 100) : 0,
            iniciais: iniciais(nome),
            base: linha.totalRegistros || 0
        };
    });
}

export function mapLinhaComissaoConselheiro(item: ComissaoEstatisticaAnaliticoResponse): PendenciaLinha {
    return {
        crm: item.idEstruturaOrganizacional != null ? `#${item.idEstruturaOrganizacional}` : '-',
        nome: item.dsEstruturaOrganizacional || 'Comissão',
        uf: item.grupoDescricao || '-',
        situacao: 'Ativa'
    };
}
